import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import {
  DefaultsService,
  EquipmentService,
  SettingsService,
  LocaleService,
  PermissionsService,
  LocalStorageService,
} from './providers';
import { ErrorService } from './providers/services/error.service';
import { InterceptorModule } from './providers/interceptors/http.interceptor';
import { OverlayComponent } from './overlay/overlay.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MqaCurrencyPipe } from './providers';
import { SearchService } from './providers/services/search.service';
import { NavService } from './providers/services/nav.service';
import { SearchResultsComponent } from './search-results/search-results.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentBase } from '../pages/component.base';
import { TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LanguageInterceptor } from './providers/interceptors/language.interceptor';
import { TranslateLabelPipe } from './pipes/translate-label.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { MetricsApiService } from './http/MetricsApi.service';
import { FeatureFlagModule } from 'src/app/core/feature-flags/feature-flag.module';
import { InputAutosizeDirective } from './directives/input-autosize.directive';
import { InputNumbersOnlyDirective } from './directives/input-numbers-only.directive';
import { DialogService } from './dialogs/dialog.service';
import { DisclaimersModule } from './disclaimers/disclaimers.module';

@NgModule({
  declarations: [
    ComponentBase,
    OverlayComponent,
    ProgressBarComponent,
    MqaCurrencyPipe,
    SearchResultsComponent,
    TranslateLabelPipe,
    LocalizedDatePipe,
    InputAutosizeDirective,
    InputNumbersOnlyDirective,
  ],
  imports: [
    CommonModule,
    InterceptorModule,
    MatProgressBarModule,
    MatTooltipModule,
    TranslateModule,
    FeatureFlagModule,
  ],
  providers: [
    SettingsService,
    LocaleService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    EquipmentService,
    DefaultsService,
    ErrorService,
    CurrencyPipe,
    DecimalPipe,
    SearchService,
    NavService,
    MetricsApiService,
    PermissionsService,
    DialogService,
    LocalStorageService,
  ],
  exports: [
    ComponentBase,
    OverlayComponent,
    ProgressBarComponent,
    MqaCurrencyPipe,
    SearchResultsComponent,
    TranslateModule,
    TranslateLabelPipe,
    LocalizedDatePipe,
    FeatureFlagModule,
    InputAutosizeDirective,
    InputNumbersOnlyDirective,
  ],
})
export class CoreModule {}
